// Configuration file for the application
// This ensures environment variables are properly bundled with the app

// API URL - Use environment variable or fallback to the hardcoded API Gateway URL
export const API_URL = process.env.REACT_APP_API_URL || 'https://2w4qrncaf1.execute-api.us-east-1.amazonaws.com/dev';

// reCAPTCHA site key
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfCr-MqAAAAAEMsObYjY1fVi0Wn0A5MpyOA5AN9';

// Check if we're in development mode
export const isDevelopment = process.env.NODE_ENV === 'development';

// Check if we're on localhost
export const isLocalhost = 
  typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Log configuration on startup
console.log('Application configuration:');
console.log('- API URL:', API_URL);
console.log('- Environment:', process.env.NODE_ENV);
console.log('- Is localhost:', isLocalhost); 